import * as React from 'react';
import { Button, Modal } from 'antd';
import { BoxHeader } from 'one-ui-box';
import './style.less';
import { useCtx } from 'one-ui-provider';

/**
 * Represents MapModal Props Attributes
 */
interface MapModalProps {
  open: boolean;
  title: string;
  content: JSX.Element;
  onOpenSMSModal: () => void;
  onClose: () => void;
}

/**
 * This function returns the Map Modal
 * @param props has all input parameters to load the Card
 * @returns JSX code for Pop-up Modal for the Map
 */
export const MapModal = ({ open, title, content, onOpenSMSModal, onClose }: MapModalProps): JSX.Element => {
  const { settings: { map_config } } = useCtx();
  const { send_sms } = map_config;
  return (
    <Modal
      visible={open}
      closable={false}
      destroyOnClose
      mask
      maskClosable
      wrapClassName="map-modal"
      footer={null}
      getContainer={false}
      onCancel={onClose}
    >
      <BoxHeader title={title} titleWidth={12}>
        <Button size="small" className="ant-btn--spacer" onClick={onClose}>
          Exit Full Map
        </Button>
        {(send_sms) && (<Button size="small" type="primary" className="ant-btn--spacer" onClick={onOpenSMSModal}>
          Send SMS
        </Button>)}
      </BoxHeader>
      {content}
    </Modal>
  );
};

export default MapModal;
